<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.Chat' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <sl-chat-conversation [messages]="messages()" />
    </mat-card-content>
</mat-card>
